@if (documentsArray.controls.length > 0) {
  <div class="container-fluid p-1 position-relative">
    @if (isLoading) {
<loader [config]="{
  fullScreen: false,
  overlay: true,
  type: 'spinner',
  size: 'md',
  text: 'Loading...'
}"/>
    }
    @if (alertInfo.show) {
      <ngb-alert
        [type]="alertInfo.type"
        (closed)="alertInfo.show = false"
        >
        {{ alertInfo.message }}
      </ngb-alert>
    }
    @for (documentGroup of documentsArray.controls; track documentGroup; let i = $index) {
      <div class="card mb-3" [formGroup]="getFormGroup(documentGroup)">
        <div class="card-body p-2">
          <div class="row g-2 align-items-end">
            <div class="col-md-4">
              <select-field
                [label]="'Language'"
                [options]="languageOptions"
                [selectFormControl]="getFormControl(documentGroup.get('languageId'))"
                [readonly]="readonlyCustomersDocumentsForNewClients">
              </select-field>
            </div>
            <div class="col-md-4">
              <input-field
                [label]="'Document Name'"
                [placeholder]="'Enter document name'"
                [inputFormControl]="getFormControl(documentGroup.get('name'))"
                [readonly]="readonlyCustomersDocumentsForNewClients">
            </input-field>
          </div>
          <div class="col-md-3">
            <button class="btn btn-outline-primary d-flex align-items-center w-100 file-button align-control-btn" (click)="viewFile(documentGroup.get('url'))" >
              <i class="fa fa-solid fa-eye me-2 file-icon"></i>
              <div class="filename-container">
                <span class="filename-text">
                  {{ getTruncatedFileName(documentGroup.get('fileName')?.value).truncatedName }}
                </span>
                <span class="file-extension">
                  {{ getTruncatedFileName(documentGroup.get('fileName')?.value).extension }}
                </span>
              </div>
            </button>
          </div>
          <div class="col-md-1">
            <button class="btn btn-outline-danger align-control-btn w-100" (click)="confirmDelete(documentGroup)">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  }
  <div class="row mt-4">
    <div class="col-md-12 text-end">
      <input type="file" #fileInput (change)="onFileSelected($event)" style="display: none;"/>
      <button class="btn btn-primary me-2" (click)="fileInput.click()">Add file</button>
      <button class="btn btn-success" (click)="submitForm()">Save</button>
    </div>
  </div>
</div>
}